export class TimeIndicator {
  public draw = (gl: CanvasRenderingContext2D, xPos: number, color: string): void => {
    gl.save();
    gl.strokeStyle = color;
    gl.beginPath();
    gl.moveTo(xPos, 0);
    gl.lineWidth = 2;
    gl.lineTo(xPos, gl.canvas.height);
    gl.stroke();
    gl.restore();
  };
}
